import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IActionResult } from '../types/IActionResult';

export interface ISetContentControlledPermissionsParams {
  ids: string[];
  nestedProjectsPermissionsIncluded?: boolean;
}

export class SetContentControlledPermissionsRequest
    extends Request<ISetContentControlledPermissionsParams, IActionResult> {
  constructor(params: ISetContentControlledPermissionsParams) {
    super('setContentControlledPermissions', params);
  }
}
